import type { Course, Maybe } from '@edwin-group/cj-graphql/generated/graphql';
import LessonCard from '@/components/Learn/Lesson';
import SubContainer from '@/components/Container/SubContainer';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

export type courseWithLearnProps = Course & { learn?: { completed?: boolean; learnCount?: number } };

function CardCourseGroupedByCategory({
  category,
}: {
  category: {
    name: string;
    description: string;
    courses: (Maybe<courseWithLearnProps> | undefined)[];
  };
}) {
  return (
    <SubContainer className="lg:col-start-3 lg:col-end-11">
      <div className="flex flex-wrap">
        {category?.courses?.map((course) => {
          const lessonsCount =
            course?.modules?.reduce((acc, curr) => {
              return acc + (curr?.lessons || [])?.length || 0;
            }, 0) || 1;

          return (
            <AnimatedFadeInComponent key={course!.title!}>
              <div className="mt-sh-30">
                <LessonCard
                  title={course!.title}
                  description={course!.description}
                  thumbnail={course!.thumbnail}
                  url={`/learn/course/${course?.slug}`}
                  key={course!.title!}
                  tag="Course"
                  duration={course?.duration || ''}
                  watchLabel="Continue"
                  progress={course?.learn?.completed ? 100 : ((course?.learn?.learnCount || 1) / lessonsCount) * 100}
                  done={course?.learn?.completed}
                />
              </div>
            </AnimatedFadeInComponent>
          );
        })}
      </div>
    </SubContainer>
  );
}

export default CardCourseGroupedByCategory;
